import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue')
  }, {
    path: '/my',
    name: 'my',
    component: () => import('../views/my.vue')
  }, {
    path: '/chat',
    name: 'chat',
    component: () => import('../views/chat.vue')
  },
  {
    path: '/login', //登录
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/agreement.vue')
  },
  {
    path: '/lawyerHelp',
    name: 'lawyerHelp',
    component: () => import('../views/lawyerHelp.vue')
  },
  {
    path: '/robot',
    name: 'robot',
    component: () => import('../views/robot.vue')
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order.vue')
  },
  {
    path: '/wait_all',
    name: 'wait_all',
    component: () => import('../views/wait_all.vue')
  },
  {
    path: '/chatroom',
    name: 'chatroom',
    component: () => import('../views/chatroom.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail.vue')
  },
  {
    path: '/popularize',
    name: 'popularize',
    component: () => import('../views/popularize.vue')
  },
  {
    path: '/wait_directional',
    name: 'wait_directional',
    component: () => import('../views/wait_directional.vue')
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('../views/video.vue')
  }, {
    path: '/law',
    name: 'law',
    component: () => import('../views/law.vue')
  }, {
    path: '/mediate',
    name: 'mediate',
    component: () => import('../views/mediate.vue')
  }, {
    path: '/notarization',
    name: 'notarization',
    component: () => import('../views/notarization.vue')
  }, {
    path: '/judicial',
    name: 'judicial',
    component: () => import('../views/judicial.vue')
  }, {
    path: '/community',
    name: 'community',
    component: () => import('../views/community.vue')
  }, {
    path: '/lawDetail',
    name: 'lawDetail',
    component: () => import('../views/lawDetail.vue')
  },
  {
    path: '/complaint',
    name: 'complaint',
    component: () => import('../views/complaint.vue')
  },
  {
    path: '/chatroom_order',
    name: 'chatroom_order',
    component: () => import('../views/chatroom_order.vue')
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: () => import('../views/evaluate.vue')
  },
  {
    path: '/agency',
    name: 'agency',
    component: () => import('../views/agency.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/agency_detail',
    name: 'agency_detail',
    component: () => import('../views/agency_detail.vue')
  },
  {
    path: '/agency_search',
    name: 'agency_search',
    component: () => import('../views/agency_search.vue'),
    meta: {
      keepAlive: true
    }
  }, {
    path: '/orderList',
    name: 'orderList',
    component: () => import('../views/orderList.vue')
  }, {
    path: '/docList',
    name: 'docList',
    component: () => import('../views/docList.vue')
  }, {
    path: '/applyOrder',
    name: 'applyOrder',
    component: () => import('../views/applyOrder.vue')
  }, {
    path: '/evaluateIndex',
    name: 'evaluateIndex',
    component: () => import('../views/evaluateIndex.vue')
  }, {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('../views/orderDetail.vue')
  }, {
    path: '/applyDetail',
    name: 'applyDetail',
    component: () => import('../views/applyDetail.vue')
  }, {
    path: '/lawArtical',
    name: 'lawArtical',
    component: () => import('../views/lawArtical.vue')
  }, {
    path: '/lawArticalDetail',
    name: 'lawArticalDetail',
    component: () => import('../views/lawArticalDetail.vue')
  }, {
    path: '/classics',
    name: 'classics',
    component: () => import('../views/classics.vue')
  }, {
    path: '/search',
    name: 'search',
    component: () => import('../views/search.vue')
  }, {
    path: '/searchCase',
    name: 'searchCase',
    component: () => import('../views/searchCase.vue')
  }, {
    path: '/case',
    name: 'case',
    component: () => import('../views/case.vue')
  }, {
    path: "/caseDetail",
    name: 'caseDetail',
    component: () => import('../views/caseDetail.vue')
  }, {
    path: "/comic",
    name: 'comic',
    component: () => import('../views/comic.vue')
  }, {
    path: '/comicDetail',
    name: 'comicDetail',
    component: () => import('../views/comicDetail.vue')
  }, {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/personal.vue')
  }, {
    path: '/docModel',
    name: 'docModel',
    component: () => import('../views/docModel.vue')
  }, {
    path: '/docSearch',
    name: 'docSearch',
    component: () => import('../views/docSearch.vue')
  }, {
    path: '/calculator',
    name: 'calculator',
    component: () => import('../views/calculator.vue'),
     meta: {
      keepAlive: true
    }
  }, {
    path: '/condition',
    name: 'condition',
    component: () => import('../views/condition.vue'),
  },{
    path: '/doc',
    name: 'doc',
    component: () => import('../views/doc.vue'),
  },{
    path: '/wait_serve',
    name: 'wait_serve',
    component: () => import('../views/wait_serve.vue'),
  },{
    path: '/local',
    name: 'local',
    component: () => import('../views/local.vue'),
  },{
    path: '/lawyer',
    name: 'lawyer',
    component: () => import('../views/lawyer.vue'),
  },{
    path: '/evaluate_list',
    name: 'evaluate_list',
    component: () => import('../views/evaluate_list.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router